import React, { useEffect, useState } from "react";
import { Container, Row, Col, Table, Card, Pagination } from "react-bootstrap";
import "../../userreport.css";
import { IoIosArrowForward, IoMdEye } from "react-icons/io";
import { useNavigate, Link } from "react-router-dom";
import { getunverifiedUser } from "../../store/slices/user";
import { useSelector, useDispatch } from "react-redux";

const FILTERS = ["All", "Active", "Inactive", "Verified", "Pending"];

function getInitials(name = "") {
  return name
    .split(" ")
    .slice(0, 2)
    .map((n) => n[0]?.toUpperCase() || "")
    .join("");
}

export default function UnverifiedUser() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [limit] = useState(10);
  const [filter, setFilter] = useState("All");
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [meta, setMeta] = useState({ total: 0, page: 1, limit: 10 });
  const [statsData, setStatsData] = useState({
    totalUsers: 0,
    activeUsers: 0,
    inactiveUsers: 0,
    verifiedUsers: 0,
    pendingUsers: 0,
    blockedUsers: 0,
  });

  const { unverifieduserlist = [] } = useSelector((state) => state.user);

  useEffect(() => {
    const params = {
      page: currentPage,
      limit,
    };

    if (search.trim()) {
      params.search = search.trim();
    }

    switch (filter) {
      case "Active":
        params.isActive = true;
        break;

      case "Inactive":
        params.isActive = false;
        break;

      case "Verified":
        params.profileVerified = true;
        break;

      case "Pending":
        params.profileVerified = false;
        break;

      default:
        break;
    }

    dispatch(getunverifiedUser(params)).then((res) => {
      const payload = res.payload || {};

      setMeta({
        total: payload.total || 0,
        page: payload.page || 1,
        limit: payload.limit || limit,
      });

      setStatsData(
        payload.stats || {
          totalUsers: 0,
          activeUsers: 0,
          inactiveUsers: 0,
          verifiedUsers: 0,
          pendingUsers: 0,
          blockedUsers: 0,
        }
      );
    });
  }, [dispatch, currentPage, limit, search, filter]);

  const total = meta.total;
  const totalPages = Math.max(1, Math.ceil(total / limit));



  const stats = [
    {
      title: "Total Users",
      value: statsData.totalUsers,
      iconClass: "icon-total",
      icon: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        >
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      ),
    },
    {
      title: "Active",
      value: statsData.activeUsers,
      iconClass: "icon-active",
      sub: "of total",
      icon: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        >
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
        </svg>
      ),
    },
    {
      title: "Verified",
      value: statsData.verifiedUsers,
      iconClass: "icon-verified",
      icon: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        >
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
      ),
    },
    {
      title: "Pending",
      value: statsData.pendingUsers,
      iconClass: "icon-pending",
      icon: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        >
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      ),
    },
    {
      title: "Suspended",
      value: statsData.blockedUsers,
      iconClass: "icon-suspended",
      icon: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
        </svg>
      ),
    },
  ];


  const formatDate = (iso) => {
    if (!iso) return "—";
    return new Date(iso).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const handleView = (candidate) => {
    navigate(`/admin/candidatedetails/${candidate._id}`, { state: candidate });
  };

  return (
    <>
      <div className="breadcrumb-bar mb-4">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>
          <span className="breadcrumb-separator">
            <IoIosArrowForward size={15} />
          </span>
          <span className="breadcrumb-link active">Attempted Candidates</span>
        </div>
      </div>

      <Container className="cl-container">
        {/* Page heading */}
        <div className="cl-page-header">
          <div>
            <h1 className="cl-page-title">Attempted Candidates</h1>
          </div>
        </div>



        {/* Table card */}
        <Card className="cl-table-card">
          {/* Toolbar */}
          <div className="cl-toolbar">
            <div className="cl-toolbar-left">

            </div>
            <div className="cl-toolbar-right">
              <div className="cl-search-wrap">
                <svg
                  className="cl-search-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <circle cx="11" cy="11" r="8" />
                  <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
                <input
                  className="cl-search"
                  placeholder="Search by name, ID, email…"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setCurrentPage(1);
                  }}
                />
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="table-responsive">
            <Table className="cl-table align-middle">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Gender</th>
                  <th>Mobile</th>
                  <th>Email</th>
                  <th>Aadhaar Status</th>

                  <th>Profile</th>
                  <th>Joined</th>

                </tr>
              </thead>
              <tbody>
                {unverifieduserlist?.length ? (
                  unverifieduserlist.map((u, index) => (
                    <tr key={u._id}>
                      <td className="cl-row-num">
                        {String((currentPage - 1) * limit + index + 1).padStart(2, "0")}
                      </td>

                      <td>
                        <div className="cl-candidate-info">
                          <div
                            className={`cl-avatar ${u.gender?.toLowerCase() === "female"
                              ? "cl-avatar--f"
                              : "cl-avatar--m"
                              }`}
                          >
                            {getInitials(u.name)}
                          </div>

                          <div>
                            <div className="cl-cand-name">{u.name || "-"}</div>
                            <div className="cl-cand-meta">
                              <span className="cl-cand-id">
                                {u._id?.slice(-8)?.toUpperCase()}
                              </span>
                            </div>
                          </div>
                        </div>
                      </td>

                      <td>
                        <span
                          className={`cl-badge cl-badge--${u.gender?.toLowerCase() === "female" ? "female" : "male"
                            }`}
                        >
                          {u.gender || "-"}
                        </span>
                      </td>

                      <td className="cl-phone">{u.mobileNumber || "-"}</td>

                      <td className="cl-phone">{u.email || "-"}</td>

                      <td>
                        <span
                          className={`cl-badge ${u.aadhaarVerified
                            ? "cl-badge--active"
                            : "cl-badge--inactive"
                            }`}
                        >
                          <span className="cl-badge-dot" />
                          {u.aadhaarVerified ? "Verified" : "Unverified"}
                        </span>
                      </td>

                      <td>
                        <span
                          className={`cl-badge ${u.profileVerified
                            ? "cl-badge--verified"
                            : "cl-badge--unverified"
                            }`}
                        >
                          {u.profileVerified ? "Verified" : "Unverified"}
                        </span>
                      </td>

                      <td className="cl-date">
                        {formatDate(u.createdAt)}
                      </td>


                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={9} className="cl-empty text-center py-4">
                      No candidates found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          {/* Footer / Pagination */}
          <div className="cl-table-footer">
            <span className="cl-pagination-info">
              Showing {total === 0 ? 0 : (currentPage - 1) * limit + 1}–
              {Math.min(currentPage * limit, total)} of {total} &nbsp;·&nbsp;
              Page {currentPage} of {totalPages}
            </span>
            <Pagination className="cl-pagination">
              <Pagination.Prev
                onClick={() => setCurrentPage((p) => p - 1)}
                disabled={currentPage === 1}
              />
              {[...Array(totalPages)].map((_, i) => (
                <Pagination.Item
                  key={i}
                  active={i + 1 === currentPage}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </Pagination.Item>
              ))}
              <Pagination.Next
                onClick={() => setCurrentPage((p) => p + 1)}
                disabled={currentPage === totalPages}
              />
            </Pagination>
          </div>
        </Card>
      </Container>
    </>
  );
}
